import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * Builds the creation payload for a standalone event derived from `source`, linked via `extractedFromId`.
 */
export function extractStandaloneEvent(source, changes) {
  const createdEvent = _extends({}, source.modelInBuiltInFormat, changes, {
    extractedFromId: source.id
  });

  // @ts-ignore
  delete createdEvent.id;
  delete createdEvent.rrule;
  delete createdEvent.exDates;
  return createdEvent;
}